import activities from "./activities/index"
import projects from "./projects/index"
import technologies from "./technologies/index"
import templates from "./templates/index"

import amountUnits from "./amountUnits"
import customers from "./customers"
import dashboardRoles from "./dashboardRoles"
import deletePlanningObjects from "./deletePlanningObjects"
import holidays from "./holidays"
import imports from "./imports"
import licenceModules from "./licenceModules"
import modules from "./modules"
import operations from "./operations"
import orderPositions from "./orderPositions"
import productionOrders from "./productionOrders"
import resources from "./resources"
import userList from "./userList"

export default [
  ...technologies,
  ...imports,
  ...templates,
  ...resources,
  ...customers,
  ...deletePlanningObjects,
  ...holidays,
  ...projects,
  ...orderPositions,
  ...activities,
  ...productionOrders,
  ...operations,
  ...amountUnits,
  ...licenceModules,
  ...userList,
  ...dashboardRoles,
  ...modules,
]
